<template>
  <v-app>
    <v-app-bar
      v-show="!showFullScreen"
      app
      color="primary"
      dark
    >
      <v-icon :style="{'visibility': goBack ? 'visible' : 'hidden'}" @click="$router.go(-1)">
        mdi-chevron-left
      </v-icon>

      <v-spacer></v-spacer>

      <v-toolbar-title>
        <router-link :to="{'name': 'home'}">
          <img src="/zitat-nobg.svg" alt="Zitat" class="logo"/>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <div v-if="loggedIn">
        <v-btn :to="{'name': 'settings'}" small fab color="secondary">
          {{ userNameInitial }}
        </v-btn>
      </div>

    </v-app-bar>

    <v-content>
       <transition
        :name="transitionName"
         mode="out-in"
         >
        <router-view @updatenav="updateNav"/>
      </transition>
      <v-snackbar
      :value="hasSnack"
      bottom
      :timeout="0"
      absolute
      >
        <template v-if="syncing">
          Saving...
        </template>
        <template v-if="updating">
          Updating...
        </template>
        <template v-if="updateReady">
          Update available! <v-btn color="green" @click="startUpdate">Update now</v-btn>
        </template>
      </v-snackbar>
    </v-content>

    <v-bottom-navigation
        app
        class="bottom-nav"
        v-show="!showFullScreen"
        color="primary"
        :height="75"
        grow
      >
      <v-btn :to="{ name: 'home' }" exact :class="{'v-btn--active': quoteNavActive}">
        <span>Quotes</span>
        <v-icon>mdi-comment-quote</v-icon>
      </v-btn>

      <!-- <div class="v-btn v-btn--contained v-btn--router theme--light v-size--default">
        <input type="file" id="addquote-file" ref="addquoteFile" @change="fileChosen" accept="image/jpeg"/>
        <label for="addquote-file" class="v-btn__content" @click="fileClick">
          <span>Add Quote</span>
          <v-icon>mdi-tooltip-plus</v-icon>
        </label>
      </div> -->

      <v-btn :to="{ name: 'add' }" exact>
        <span>Add Quote</span>
        <v-icon>mdi-tooltip-plus</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'settings' }">
        <span>Settings</span>
        <v-icon>mdi-settings</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import applyUpdate from 'serviceworker-webpack-plugin/lib/browser/applyUpdate'

const DEFAULT_TRANSITION = 'slide'

export default {
  name: 'app',
  data () {
    return {
      fileDialogOpen: false,
      goBack: false,
      transitionName: DEFAULT_TRANSITION
    }
  },
  computed: {
    ...mapState([
      'token', 'books', 'online',
      'updating', 'syncing', 'updateReady'
    ]),
    ...mapGetters([
      'loggedIn', 'userName'
    ]),
    userNameInitial () {
      if (this.userName.length > 0) {
        return this.userName[0].toUpperCase()
      }
      return '?'
    },
    hasSnack () {
      return this.syncing || this.updating || this.updateReady
    },
    showFullScreen () {
      return this.$route.name === 'add'
    },
    quoteNavActive () {
      return this.$route.name !== 'add' && this.$route.name !== 'settings'
    }
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName

      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION
      next()
    })
  },
  mounted () {
    window.addEventListener('online', () => {
      this.$store.commit('setOnline', true)
      this.sync()
    })
    window.addEventListener('offline', () => {
      this.$store.commit('setOnline', false)
    })
    this.$router.afterEach((to, from) => {
      this.goBack = false
    })
  },
  methods: {
    ...mapActions(['sync', 'updateFromRemote']),
    fileClick (e) {
      if (this.fileDialogOpen) {
        e.preventDefault()
        this.goToAdd()
      } else {
        this.fileDialogOpen = true
      }
    },
    goToAdd () {
      this.$router.push({ name: 'add' })
    },
    fileChosen () {
      this.fileDialogOpen = false
      this.$store.commit('setFile', this.$refs.addquoteFile.files[0])
      this.$refs.addquoteFile.value = ''
      this.goToAdd()
    },
    updateNav () {
      this.goBack = true
    },
    startUpdate () {
      this.$store.commit('updateReady', false)
      this.$store.commit('setUpdating', true)
      applyUpdate().then(() => {
        this.$store.commit('setUpdating', false)
        window.location.reload()
      })
    }
  }
}
</script>

<style>
@import '~@mdi/font/css/materialdesignicons.css';

.bottom-nav .v-btn {
  height: inherit !important;
}

.logo {
  height: 50px;
  margin-top: 6px;
}

#addquote-file {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}

#addquote-file + label {
  cursor: pointer
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.15s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

</style>
